import React, { useState } from 'react';
import PropTypes from 'prop-types';

const SankeyControls = ({ 
  onParamsChange, 
  initialParams = {}, 
  showUnidadesFilter = true,
  showLimiteControl = true,
  showInactivosToggle = true 
}) => {
  const [params, setParams] = useState({
    limite: initialParams.limite || 60,
    unidades: initialParams.unidades || [],
    incluirInactivos: initialParams.incluirInactivos || false
  });

  const [unidadesInput, setUnidadesInput] = useState(
    initialParams.unidades ? initialParams.unidades.join(',') : ''
  );

  const handleLimiteChange = (e) => {
    const newLimite = parseInt(e.target.value) || 60;
    const newParams = { ...params, limite: newLimite };
    setParams(newParams);
    onParamsChange(newParams);
  };

  const handleUnidadesChange = (e) => {
    const value = e.target.value;
    setUnidadesInput(value);
    
    const unidadesArray = value
      .split(',')
      .map(u => u.trim())
      .filter(u => u.length > 0);
    
    const newParams = { ...params, unidades: unidadesArray };
    setParams(newParams);
    onParamsChange(newParams);
  };

  const handleInactivosChange = (e) => {
    const newParams = { ...params, incluirInactivos: e.target.checked };
    setParams(newParams);
    onParamsChange(newParams);
  };

  const resetToDefaults = () => {
    const defaultParams = {
      limite: 60,
      unidades: [],
      incluirInactivos: false
    };
    setParams(defaultParams);
    setUnidadesInput('');
    onParamsChange(defaultParams);
  };

  const handleFocus = () => {
    // No-op para accesibilidad
  };

  return (
    <div className="sankey-controls" style={{ 
      padding: '1rem', 
      backgroundColor: '#f8f9fa', 
      borderRadius: '8px', 
      marginBottom: '1rem',
      border: '1px solid #e9ecef'
    }}>
      <h4 style={{ marginBottom: '1rem', color: '#495057' }}>Configuración de Gráfica Sankey</h4>
      
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', alignItems: 'center' }}>
        {showLimiteControl && (
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: '150px' }}>
            <label htmlFor="limite" style={{ fontSize: '0.9rem', marginBottom: '0.25rem', color: '#6c757d' }}>
              Registros por sensor:
            </label>
            <input
              id="limite"
              type="number"
              min="1"
              max="1000"
              value={params.limite}
              onChange={handleLimiteChange}
              style={{
                padding: '0.5rem',
                border: '1px solid #ced4da',
                borderRadius: '4px',
                fontSize: '0.9rem'
              }}
            />
          </div>
        )}

        {showUnidadesFilter && (
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: '200px', flex: 1 }}>
            <label htmlFor="unidades" style={{ fontSize: '0.9rem', marginBottom: '0.25rem', color: '#6c757d' }}>
              Filtrar por unidades (separadas por coma):
            </label>
            <input
              id="unidades"
              type="text"
              placeholder="Ej: Kwh,Lts,M³,°C"
              value={unidadesInput}
              onChange={handleUnidadesChange}
              style={{
                padding: '0.5rem',
                border: '1px solid #ced4da',
                borderRadius: '4px',
                fontSize: '0.9rem'
              }}
            />
            <small style={{ color: '#6c757d', marginTop: '0.25rem' }}>
              Deja vacío para incluir todas las unidades
            </small>
          </div>
        )}

        {showInactivosToggle && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input
              id="incluirInactivos"
              type="checkbox"
              checked={params.incluirInactivos}
              onChange={handleInactivosChange}
              onFocus={handleFocus}
              onBlur={handleFocus}
              style={{ transform: 'scale(1.2)' }}
            />
            <label htmlFor="incluirInactivos" style={{ fontSize: '0.9rem', color: '#6c757d' }}>
              Incluir dispositivos inactivos
            </label>
          </div>
        )}

        <button
          onClick={resetToDefaults}
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '0.9rem',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#5a6268'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#6c757d'}
          onFocus={handleFocus}
          onBlur={handleFocus}
        >
          Restablecer
        </button>
      </div>

      <div style={{ marginTop: '0.75rem', fontSize: '0.8rem', color: '#6c757d' }}>
        <strong>Configuración actual:</strong>
        {' '}
        {params.limite} registros por sensor
        {params.unidades.length > 0 && `, unidades: ${params.unidades.join(', ')}`}
        {params.incluirInactivos && ', incluyendo inactivos'}
      </div>
    </div>
  );
};

SankeyControls.propTypes = {
  onParamsChange: PropTypes.func.isRequired,
  initialParams: PropTypes.shape({
    limite: PropTypes.number,
    unidades: PropTypes.arrayOf(PropTypes.string),
    incluirInactivos: PropTypes.bool
  }),
  showUnidadesFilter: PropTypes.bool,
  showLimiteControl: PropTypes.bool,
  showInactivosToggle: PropTypes.bool
};

export default SankeyControls;